import { createBroadviewClient, type BroadviewApiClient } from "@broadview/api-client";

/**
 * Transitional portal data boundary. Existing Lovable fixture exports remain
 * source-identical below, while portal-level context/provenance now comes from
 * the shared typed client. Other routes can migrate to this facade incrementally.
 */
let portalClient: BroadviewApiClient = createBroadviewClient({ mode: "fixture" });
let selectedTenantId: string | undefined;

export function configurePortalClient(client: BroadviewApiClient, tenantId?: string) {
  portalClient = client;
  selectedTenantId = tenantId;
}

export async function loadPortalContext() {
  const identity = await portalClient.identity.me();
  const tenants = await portalClient.identity.listTenants();
  const tenant = tenants.find((candidate) => candidate.tenantId === selectedTenantId) ?? tenants[0];
  if (!tenant) throw new Error("No eligible tenant workspace is available.");
  const [tenantContext, dashboard] = await Promise.all([
    portalClient.identity.getTenantContext(tenant.tenantId),
    portalClient.dashboard.get({
      tenantId: tenant.tenantId,
      view: "warranty-workbench",
    }),
  ]);
  return { identity, tenantContext, dashboard };
}

/** @deprecated Use configurePortalClient. Retained while existing portal routes migrate. */
export const configurePortalFixtureClient = configurePortalClient;
/** @deprecated Use loadPortalContext. Retained while existing portal routes migrate. */
export const loadPortalFixtureContext = loadPortalContext;

export * from "./warranty-data";
